export enum RecursosEnum {
  AGENDAMENTO_ITINERANTE = "AGENDAMENTO_ITINERANTE",
  ATRIBUIR_VISTORIA = "ATRIBUIR_VISTORIA",
  CADASTRO_METAS = "CADASTRO_METAS",
  COMUNICAR_ATRASO = "COMUNICAR_ATRASO",
  COMUNICAR_CHEGADA = "COMUNICAR_CHEGADA",
  CONFIGURACAO_CLIENTE_EDITAR = "CONFIGURACAO_CLIENTE_EDITAR",
  CONFIGURACAO_CLIENTE_VER = "CONFIGURACAO_CLIENTE_VER",
  CONFIGURACAO_COLABORADOR_EDITAR = "CONFIGURACAO_COLABORADOR_EDITAR",
  CONFIGURACAO_COLABORADOR_VER = "CONFIGURACAO_COLABORADOR_VER",
  CONFIGURACAO_CONCESSIONARIA_EDITAR = "CONFIGURACAO_CONCESSIONARIA_EDITAR",
  CONFIGURACAO_CONCESSIONARIA_VER = "CONFIGURACAO_CONCESSIONARIA_VER",
  CONFIGURACAO_DELIVERY_EDITAR = "CONFIGURACAO_DELIVERY_EDITAR",
  CONFIGURACAO_DELIVERY_VER = "CONFIGURACAO_DELIVERY_VER",
  CONFIGURACAO_FERIADO_EDITAR = "CONFIGURACAO_FERIADO_EDITAR",
  CONFIGURACAO_FERIADO_VER = "CONFIGURACAO_FERIADO_VER",
  CONFIGURACAO_ITINERANTE_EDITAR = "CONFIGURACAO_ITINERANTE_EDITAR",
  CONFIGURACAO_ITINERANTE_VER = "CONFIGURACAO_ITINERANTE_VER",
  CONFIGURACAO_LOJA_EDITAR = "CONFIGURACAO_LOJA_EDITAR",
  CONFIGURACAO_LOJA_VER = "CONFIGURACAO_LOJA_VER",
  CONFIGURACAO_PERFIL_EDITAR = "CONFIGURACAO_PERFIL_EDITAR",
  CONFIGURACAO_PERFIL_VER = "CONFIGURACAO_PERFIL_VER",
  CONFIGURACOES = "CONFIGURACOES",
  CONFIMAR_REEMBOLSO = "CONFIMAR_REEMBOLSO",
  CONFIRMAR_PAGAMENTO = "CONFIRMAR_PAGAMENTO",
  DENUNCIAS = "DENUNCIAS",
  DOCUMENTOS = "DOCUMENTOS",
  FINALIZAR_MANUAL = "FINALIZAR_MANUAL",
  MAPA_BI = "MAPA_BI",
  MINHAS_VISTORIAS = "MINHAS_VISTORIAS",
  MULTILOJA = "MULTILOJA",
  REDEFINIR_SENHA = "REDEFINIR_SENHA",
  REGISTRAR_IMPEDIMENTO = "REGISTRAR_IMPEDIMENTO",
  RETORNAR_STATUS = "RETORNAR_STATUS",
  TREINAMENTOS = "TREINAMENTOS",
}
